import axios from "axios"
import Swal from "sweetalert2"

const {
    REACT_APP_GET_CONTRACT_LIST_FILTERS: GET_CONTRACT_LIST_FILTERS,
    REACT_APP_GET_CONTRACT_LIST: GET_CONTRACT_LIST,
    REACT_APP_URI_REVIEW_CONTRACT: URI_REVIEW_CONTRACT
} = process.env

export const reviewContract = async (supplierID, contractID) => {
    try {
        Swal.fire({
            footer: 'Loading, please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        
        const { data } = await axios.post(URI_REVIEW_CONTRACT, {
            supplierID,
            contractID
        })

        Swal.close()

        return data
    } catch (error) {
        console.log("Error cuando se actualizaba el contrato: " + error)

        Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while updating contract.",
        })
    }
}

export const getContractsListFilters = async ({ params, signal }) => {
    try {
        const query = new URLSearchParams(params).toString()

        const { data } = await axios.get(`${GET_CONTRACT_LIST_FILTERS}?${query}`, { signal })

        return data
    } catch (error) {
        if (error.name === "AbortError") return

        console.error("Error fetching filters data:", error)
    }
}

export const getContractsList = async ({ params, signal }) => {
    try {
        Swal.fire({
            footer: 'Loading, please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        
        const { supplier, ...rest } = params
        
        const query = new URLSearchParams(rest)

        if (supplier.length > 0) supplier.forEach(s => query.append("supplier[]", s))

        const { data } = await axios.get(`${GET_CONTRACT_LIST}?${query.toString()}`, { signal })

        Swal.close()
        
        return data
    } catch (error) {
        if (error.name === "AbortError") return
                
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while fetching alerts.",
        })

        throw error.response?.data?.message
    }
}
